import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';

const BUSINESS_FINANCE_TAX_CLASSIFICATION_QUERY = gql`
  query BusinessFinanceTaxClassification($businessEntityUuid: UUID!) {
    businessFinanceTaxClassification(businessEntityUuid: $businessEntityUuid)
  }
`;

/**
 * Hook to fetch the business entity's tax classification.
 * @param {object} props
 * @param {boolean} [props.skip] - Whether to skip the query
 * @returns {{ taxClassification: string | null, loading: boolean, error: object | null }}
 */
export function useTaxClassification({ skip = false } = {}) {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, loading, error } = useQuery(
    BUSINESS_FINANCE_TAX_CLASSIFICATION_QUERY,
    {
      noThrow: true,
      skip: skip || !businessEntityUuid,
      variables: {
        businessEntityUuid
      }
    }
  );

  return {
    taxClassification: data?.businessFinanceTaxClassification ?? null,
    loading,
    error
  };
}
